import { StanceType, STANCE_MODIFIERS } from '../types';
import { BOSS_SPECIAL_RESISTANCE } from '../constants/bossConfig';

interface WeaponAttacker {
  strength: number;
  weaponMultiplier: number;
  stance: StanceType;
}

interface WeaponDefender {
  toughness: number;
  stance: StanceType;
}

interface SpecialAttacker {
  special: number;
  stance: StanceType;
}

/**
 * 武器攻撃のダメージ計算（新計算式）
 * 計算式: floor(A × 攻撃倍率 × B ÷ 10 × 1.5 × A ÷ (D × 防御倍率))
 * 攻撃倍率は最初のAにのみ適用
 */
export function calculateWeaponDamage(attacker: WeaponAttacker, defender: WeaponDefender): number {
  const attackMod = STANCE_MODIFIERS[attacker.stance].attackModifier;
  const defenseMod = STANCE_MODIFIERS[defender.stance].defenseModifier;

  const A = attacker.strength;
  const B = attacker.weaponMultiplier;
  const D = defender.toughness;

  const rawDamage = (A * attackMod) * B / 10 * 1.5 * A / (D * defenseMod);
  return Math.max(Math.floor(rawDamage), 1);
}

/**
 * 特殊攻撃のダメージ計算（新計算式）
 * 計算式: floor(Spc × 特殊倍率 ÷ 4)
 * 回数超過時: × 1/3
 */
export function calculateSpecialDamage(attacker: SpecialAttacker, isExceeded: boolean): number {
  const specialMod = STANCE_MODIFIERS[attacker.stance].specialModifier;
  const exceedMod = isExceeded ? 0.4 : 1.0;

  const rawDamage = attacker.special * specialMod / 4 * exceedMod;
  return Math.max(Math.floor(rawDamage), 1);
}

/**
 * リフレクター反射ダメージ計算
 * 計算式: 相手の特殊ダメージ × 反射率
 */
export function calculateReflectDamage(incomingSpecialDamage: number, reflectRate: number): number {
  const rawDamage = incomingSpecialDamage * reflectRate;
  return Math.max(Math.floor(rawDamage), 1);
}

/**
 * ボス特殊耐性によるダメージ半減
 * ゼノ魂格（エレボス）が受ける特殊系ダメージに適用
 */
export function applyBossResistance(damage: number): number {
  return Math.max(Math.floor(damage * BOSS_SPECIAL_RESISTANCE), 1);
}
